import { IDrillSimple } from './drill'
import { TeacherRoleType } from './teacher'

export enum GlobalConfigRouteMetaEnum {
  All = 'needConfigAll',
  Drills = 'needConfigDrills',
  Homework = 'needConfigHomework',
  CompetitionType = 'needCompetitionType',
  DrillCategories = 'needConfigDrillCategories',
}

export interface MetricUnit {
  name: string
  title: string
  default: number
  min: number
  max: number
  step: number
}

export interface ContainerTypeConfigItem {
  name: string
  title: string
  metric_units: MetricUnit[]
}

export interface HomeworkSelectScopeDrill {
  drill_id: string
  title: string
  default: number
  min: number
  max: number
  img_url?: string
  equipments?: string[]
  duration_seconds?: number
  difficult_level?: string
  orientation?: string
  record_type: 'score_distance' | 'score_duration' | 'score_count' | 'score'
  action_type?: string
  metric_unit: 'second' | 'count' | 'millimeter' | 'score'
}

export interface HomeworkSelectScopeItem {
  name: string
  title: string
  drills: HomeworkSelectScopeDrill[]
  default_drill_id: string
}

export interface HomeworkTemplateItem {
  name: string
  title: string
  drill: HomeworkSelectScopeDrill
}

export interface GlobalConfig {
  container_types: ContainerTypeConfigItem[]
  homework_select_scope: HomeworkSelectScopeItem[]
  default_homework: HomeworkTemplateItem[]
  drills_info?: { [k: string]: any }
  winter_holiday_homework_template: {
    [key: string]: HomeworkTemplateItem[]
  }
}

export interface IGlobalConfigDrills {
  [index: string]: IDrillSimple
}

export interface IGlobalConfigHomework {
  default_homework: HomeworkTemplateItem[]
  homework_select_scope: HomeworkSelectScopeItem[]
}

export interface ISubCategory {
  label: string
  name: string
  drill_ids: string[]
}

export interface IFirstCategory {
  label: string
  name: string
  children: ISubCategory[]
}

export type MenuRole = Record<string, Record<string, Record<string, TeacherRoleType[]>>>
